export default {
  ROOT_ELEMENT_ID: 'crazy-lister-root',
  DESKTOP_PREVIEW_ID: 'desktop-preview-text',
  MOBILE_PREVIEW_ID: 'mobile-preview-text',
  PREVIEW_TEXT: 'Everything is ok, your listing will look great once you go live.',
  MOBILE_SHORT_DESCRIPTION: 'Click here to see full item description'
};
